import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, touch } from "redux-form";
import { contactRepresentative } from "../actions/notificationActions";
import { withRouter } from "react-router";
import { withTranslation } from 'react-i18next';
import FormField from "../components/FormField";
import { required, email, length, numericality } from 'redux-form-validators'
import { SuppliersContactReasonEnum, SuppliersEnum } from "../common/enums";
import ReCAPTCHA from "react-google-recaptcha";
import Alert from "../components/Alert";
import { utils } from "../common/utils";
import { setConsultantData } from "../actions/consultantsActions";
import GoogleAddressAutoComplete from '../components/GoogleAddressAutoComplete';

//libphonenumber-js
import debounce from 'lodash.debounce';
import { validatePhoneNumberLength, isPossiblePhoneNumber, isValidPhoneNumber, parsePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import { values } from "lodash";

class ContactRepForm extends Component {
    state = {
        reCaptchaVerified: false,
        submitSuccess: false,
        showSubmitFailedMessage: false,
        reCaptchaToken: null
    };

    constructor(props) {
        super(props);

        this.debouncedPhoneValidation = debounce(this.phoneValidation, 500);
    }

    onReCaptchaChange(value) {
        console.log("Captcha value:", value);

        this.setState({ reCaptchaVerified: value ? true : false, reCaptchaToken: value });
    }

    phoneValidation = (value, allValues, props, name) => {
        try {
            let isoCodes = this.props.settings.googleGeoFilterCountriesCodes.toString().split(',');
            let isValidPhoneNumberFlag = isoCodes.some(element => (isPossiblePhoneNumber(value, element.toString().toUpperCase()) && isValidPhoneNumber(value, element.toString().toUpperCase())));
            //let isoCode= this.props.settings.locale.toString().split('-')[1];
            // let phoneNumber = parsePhoneNumber(value, isoCode);
            if (isValidPhoneNumberFlag) {
                return undefined;
            }
            else {
                return this.props.t("Invalid phone number, please provide a valid mobile or landline number in") + " " + this.props.settings.googleGeoFilterCountriesCodes.toString().toUpperCase();
            }
        } catch (error) {
            console.log(error)
            return this.props.t("Invalid phone number, please provide a valid phone number in " + this.props.settings.locale.toString().toUpperCase());
        }
    }

    validatePhone = (value, allValues, props, name) => {
        if (!value || value === -1) {
            return undefined;
        }
        this.debouncedPhoneValidation(value, allValues, props, name);
    }


    onGoogleAddressChange(mappedAddress) {
        this.props.change("address", mappedAddress.formatted_address);
        //this.setState({ disableAddressFields: false });
    }

    googleField = ({ input, label, type, meta: { touched, error, warning } }) => (

        <GoogleAddressAutoComplete initialValue={this.props.consultant ? this.props.consultant.selectedAddress.formatted_address : ""} isRequired={this.props.consultant ? true : false} settings={this.props.settings} onChange={this.onGoogleAddressChange.bind(this)}
            error={error} touched={touched} warning={warning} />

    )

    handleSubmitForm = (data) => {

        if (data) {
            data.reCaptchaToken = this.state.reCaptchaToken;
            const { consultant } = this.props;
            if (consultant) {
                data.consultantId = consultant.id;
                data.consultantName = consultant.name;
                data.consultantEmail = consultant.email;
            }
            return this.props.contactRepresentative(data).then((response) => {
                //  console.log(response)
                const isSuccess = response.value.data;
                this.setState({ submitSuccess: isSuccess });
                this.setState({ showSubmitFailedMessage: !isSuccess });
                // clear consultant data
                this.props.setConsultantData(null);

                utils.scrollTop();
            }, (error) => {
                this.props.setConsultantData(null);
                console.log(error)
                this.setState({ submitSuccess: false });
            });
        }
    };


    componentDidMount() {
        const { settings } = this.props;
        this.setState({ reCaptchaVerified: settings.googleReCaptchaSiteKey ? false : true });
        if (this.props.consultant) {
            this.props.change("contactReason", 'RequestLoginDetails')
        }
    }

    componentWillUnmount() {
        this.props.setConsultantData(null);
    }

    render() {
        //const fr = i18n.getFixedT('fr-CA');
        //const en = i18n.getFixedT('en-CA');

        const { t, handleSubmit, settings, locale, consultant } = this.props;
        if (this.state.submitSuccess)
            return (<div className="row padding-top-3x login-box"> <div className='col'><Alert type="success" msg={(`${t("ContactRepSuccessMessage")}`)} /></div></div>)

        return (
            <div className="row padding-top-3x">
                <div className="col-md-3" />
                <div className="col-md-6">
                    {this.state.showSubmitFailedMessage && <Alert type="danger" title={(`${t("Submit Failed")}`)} msg={(`${t("Unable to send your question. Please try again later.")}`)} />}
                    <form
                        className="login-box"
                        method="post"
                        onSubmit={handleSubmit(this.handleSubmitForm.bind(this))}>
                        <div className="form-group">
                            <h4>{t("Thanks for your interest in ENJO!")} </h4>
                            {consultant && <h6>{t("You are contacting:")} {consultant.name}</h6>}
                        </div>
                        <div className="form-group" style={{ display: (settings.isPluginMode || settings.isCatalogueMode) ? 'none' : 'block' }}>
                            <label htmlFor="contactReason">{t("How can I help you?")}</label><span className="red">*</span>
                            <Field name="contactReason"
                                component={FormField}
                                className="form-control"
                                validate={[required({ msg: t("is required") })]}>
                                <option value="" disabled> {t('Please Choose a Reason')}</option>
                                {SuppliersContactReasonEnum[settings.supplierId].map(key => (
                                    <option key={key} value={(`${t(key)}`)}>
                                        {(`${t(key)}`)}
                                    </option>
                                ))}
                            </Field>
                        </div>
                        <div className="form-group">
                            <label htmlFor="firstName">{t("First Name")}</label><span className="red">*</span>
                            <Field
                                className="form-control"
                                type="text"
                                name="firstName"
                                icon="icon-head"
                                autoComplete="chrome-off"
                                component={FormField}
                                placeholder={(`${t("Type your first name")}`)}
                                validate={[required({ msg: t("is required") })]}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="lastName">{t("Last Name")}</label><span className="red">*</span>
                            <Field
                                className="form-control"
                                type="text"
                                name="lastName"
                                icon="icon-head"
                                autoComplete="chrome-off"
                                component={FormField}
                                placeholder={(`${t("Type your last name")}`)}
                                validate={[required({ msg: t("is required") })]}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">{t("Phone")}</label><span className="red">*</span>
                            <Field
                                className="form-control"
                                type="number"
                                name="phone"
                                icon="pe-7s-phone"
                                autoComplete="chrome-off"
                                component={FormField}
                                placeholder={(`${t("Type your phone number")}`)}
                                validate={[required({ msg: t("is required") }), length({ max: 15, allowBlank: false, msg: t('is too long (max is {count, number} characters)') }), numericality({ int: true, allowBlank: false, msg: t('must be numbers only') }), this.phoneValidation]}
                            />
                        </div>
                        {settings.useAddressAutoCompleteInVipShop && settings.googleKey &&
                            <Field
                                name="address"
                                className="form-control"
                                component={this.googleField}
                                validate={[required({ msg: t("is required") })]}
                            ></Field>
                        }
                        <div className="form-group">
                            <label htmlFor="email">{t("Email")}</label><span className="red">*</span>
                            <Field
                                className="form-control"
                                type="text"
                                name="email"
                                icon="icon-mail"
                                autoComplete="chrome-off"
                                component={FormField}
                                placeholder={(`${t("Type your email")}`)}
                                validate={[required({ msg: t("is required") }), email({ msg: t("is invalid email") })]}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="message">{t("Message")}</label>
                            <Field
                                className="form-control"
                                type="textarea"
                                name="message"
                                icon="pe-7s-news-paper"
                                autoComplete="chrome-off"
                                component={FormField}
                                placeholder={(`${t("Type anything you would like to add")}`)}
                                validate={[length({ max: 500, allowBlank: true, msg: t('is too long (max is {count, number} characters)') })]}
                            />
                        </div>

                        {settings.googleReCaptchaSiteKey &&
                            <Fragment>
                                <div className="form-group">
                                    <label>{t("Please verify your request")}</label>
                                </div>
                                <div className="form-group">
                                    <ReCAPTCHA
                                        sitekey={settings.googleReCaptchaSiteKey}
                                        onChange={this.onReCaptchaChange.bind(this)}
                                        hl={locale}
                                    />
                                </div>
                            </Fragment>}

                        <div className="text-center text-sm-right">
                            <button
                                className="btn btn-primary margin-bottom-none"
                                disabled={!this.state.reCaptchaVerified}
                                type="submit">
                                {t("Submit")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ user, settings, locale, consultant }, ownProps) {
    return { user, settings, locale, consultant, ...ownProps };
}

ContactRepForm = connect(mapStateToProps, { contactRepresentative, setConsultantData })(ContactRepForm);

const validate = values => {
    const errors = {};
    console.log(values.address)
    if (!values.address) {
        console.log('added error')
        errors.address = "Required test";
    }

    return errors;
}

export default withTranslation()(withRouter(reduxForm({
    form: "ContactRep",

})(ContactRepForm)));
